module.exports = __webpack_public_path__ + "img/fu13.d752fa6a.png";